import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import '../css/fps.css';

// Replace with your server's URL
const SERVER_URL = 'https://my-web-counter.onrender.com/';

function Fps() {
  const [fps, setFps] = useState(0);
  const [lastFrameTime, setLastFrameTime] = useState(Date.now());
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [uniqueUsers, setUniqueUsers] = useState(0);

  useEffect(() => {
    // Function to update FPS
    const updateFps = () => {
      const now = Date.now();
      const deltaTime = now - lastFrameTime;
      setLastFrameTime(now);
      setFps(Math.round(1000 / deltaTime));
    };

    const fpsInterval = setInterval(updateFps, 1000 / 60);

    return () => clearInterval(fpsInterval);
  }, [lastFrameTime]);

  useEffect(() => {
    // Initialize socket connection
    const socket = io(SERVER_URL);

    // Function to fetch total visitors
    const fetchTotalVisitors = async () => {
      try {
        const response = await fetch('https://count.cab/get/x6YHXxvdpC');
        const data = await response.json();
        setTotalVisitors(data.count || 0);
      } catch (error) {
        console.error('Failed to fetch total visitors:', error);
      }
    };

    // Function to record a visit
    const recordVisit = async () => {
      try {
        await fetch('https://count.cab/hit/x6YHXxvdpC', { method: 'POST' });
        fetchTotalVisitors(); // Update the total visitors after recording the visit
      } catch (error) {
        console.error('Failed to record visit:', error);
      }
    };

    // Record visit and fetch total visitors when component mounts
    recordVisit();

    // Optionally, fetch total visitors periodically
    const visitorsInterval = setInterval(fetchTotalVisitors, 60000); // Update every minute

    // Handle socket events
    socket.on('updateOnlineVisitors', (count) => {
      setOnlineUsers(count);
    });

    socket.on('updateUniqueVisitors', (count) => {
      setUniqueUsers(count);
    });

    // Clean up on component unmount
    return () => {
      clearInterval(visitorsInterval);
      socket.disconnect();
    };
  }, []);

  return (
    <div className="fps-counter">
      <div>FPS: {fps}</div>
      <div>Visits: {totalVisitors}</div>
      <div>Uniq. Visitors: {uniqueUsers}</div>
      <div>On-site: {onlineUsers}</div>

    </div>
  );
}

export default Fps;
